
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/[...slug]",
      function () {
        return require("private-next-pages/offers/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers/[...slug]"])
      });
    }
  